import { Component, OnInit, Input, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { CacheService } from 'src/app/services/cache.service';
import { IEventsGroupComponentViewModel } from 'src/app/models/event/eventsGroupComponentViewModel.interface';
import { EventVM } from 'src/app/models/event/event';
import { EventsService } from 'src/app/services/events.service';
import { TicketService } from 'src/app/services/ticket.service';
import { IBet } from 'src/app/models/bet/bet';
import { IBetOutcome } from 'src/app/models/bet/betOutcome.interface';
import { StorageService } from 'src/app/services/util/storage.service';
import { EventMappingType, PageType, SBVDisplayType, SpecialOfferType } from 'src/app/models/enums';
import { IBetTypeGroup } from 'src/app/models/betType/betTypeGroup.interface';
import { IBetsAndOutcomesForBetTypeGroup } from 'src/app/models/bet/betsAndOutcomesForBetTypeGroup.interface';
import { IBetTypeGroupingTemplateItem } from 'src/app/models/betType/betTypeGroupingTemplateItem.interface';
import { Subscribable, Subscription } from 'rxjs';
import { SportsService } from 'src/app/services/sports.service';
import { ViewConfigurations } from 'src/app/models/util/viewConfigurations';

@Component({
  selector: 'app-events-group',
  templateUrl: './events-group.component.html',
  styleUrls: ['./events-group.component.less']
})
export class EventsGroupComponent implements OnInit, OnDestroy {

  // arr = Array;
  // private language: string;
  // languageForBetradar: string;
  // eventMappingTypeEnum = EventMappingType;
  selectedBetTypeGroup: IBetTypeGroup;
  selectedBetTypeGroupingTemplateItems: IBetTypeGroupingTemplateItem[] = [];
  betsAndOutcomesForEvents: { [eventId: number]: IBetsAndOutcomesForBetTypeGroup } = {};
  sbvDisplayTypeEnum = SBVDisplayType;
  public eventMappingTypeEnum = EventMappingType;
  public specialOfferTypeEnum = SpecialOfferType;
  private isInitialEventsLoad = true;
  public viewConfigurations = ViewConfigurations;

  private subscription: Subscription = new Subscription();

  constructor(
    private cache: CacheService,
    private sportsService: SportsService,
    // private eventsService: EventsService,
    // private ticketService: TicketService,
    // private storage: StorageService
  ) {
    // this.language = storage.language;
    // this.languageForBetradar = this.language === 'sr' ? 'srl' : this.language;
    this.subscription.add(this.cache.betsAndOutcomesAddedRemoved$.subscribe(x => this.updateEventBets(x)));
    this.subscription.add(this.sportsService.selectedBetTypeGroupForSrcChanged$.subscribe(x => {
      if (x.sId !== this.eventsGroupVM.sportId
        || x.rId !== this.eventsGroupVM.regionId
        || x.cId !== this.eventsGroupVM.competitionId) {
        return;
      }

      this.setSelectedBetTypeGroup({
        betTypeGroup: this.sportsService.selectedBetTypeGroupAndTemplateItemsForSports[this.eventsGroupVM.sportId].betTypeGroup,
        betTypeGroupingTemplateItems: this.sportsService.selectedBetTypeGroupAndTemplateItemsForSports[this.eventsGroupVM.sportId].betTypeGroupingTemplateItems
      });
    }));
  }

  @Input()
  eventsGroupVM: IEventsGroupComponentViewModel;

  @Input()
  selectionChanged: boolean;

  @Input()
  pageType: PageType;

  showH2Hwidget = false;

  // ngOnChanges(changes: SimpleChanges): void {
  //   if (!this.eventsGroupVM || !this.eventsGroupVM.betTypeGroups[0] || !this.selectedBetTypeGroup) {
  //     return;
  //   }
  //   this.setSelectedBetTypeGroup({ betTypeGroup: this.eventsGroupVM.betTypeGroups[0], betTypeGroupingTemplateItems: this.eventsGroupVM.betTypeGroups[0].betTypeGroupingTemplateItems });
  // }

  ngOnInit(): void {
    this.isInitialEventsLoad = false;

  }

  headToHeadWidget() {
    this.showH2Hwidget = !this.showH2Hwidget;
    console.log(this.showH2Hwidget, 'esgas');
  }

  private updateEventBets(eventIdsOfaddedRemovedBetsAndOutcomes: number[]) {
    if (!this.eventsGroupVM) {
      return;
    }
    const eventIds = this.eventsGroupVM.events.map(ev => ev.id);
    for (const eventId of eventIds) {
      if (eventIdsOfaddedRemovedBetsAndOutcomes.includes(+eventId)) {
        // make method
        if (this.selectedBetTypeGroup.betTypeGroupingTemplateItems) {
          this.cache.getBetsAndOutcomesForBetTypeGroupingTemplateItemsOfEvent(+eventId, this.selectedBetTypeGroup.betTypeGroupingTemplateItems).subscribe(betsAndOutcomesForEvents => this.betsAndOutcomesForEvents[eventId] = betsAndOutcomesForEvents);

        }
      }
    }
  }

  setSelectedBetTypeGroup(groupAndTemplateItems: { betTypeGroup: IBetTypeGroup; betTypeGroupingTemplateItems: IBetTypeGroupingTemplateItem[] }) {
    this.selectedBetTypeGroup = groupAndTemplateItems.betTypeGroup;
    this.selectedBetTypeGroupingTemplateItems = groupAndTemplateItems.betTypeGroupingTemplateItems;
    if (!this.eventsGroupVM.specialOfferType && this.pageType !== PageType.Soon && this.pageType !== PageType.MostPopular  /*&& this.pageType !== PageType.TodayOffer*/) {
      if (this.eventsGroupVM.competitionId) {
        this.cache.getBetsAndOutcomesForBetTypeGroupForCompetition(
          this.selectedBetTypeGroup,
          this.eventsGroupVM.sportId,
          this.eventsGroupVM.regionId,
          this.eventsGroupVM.competitionId,
          this.eventsGroupVM.events,
          this.selectedBetTypeGroupingTemplateItems).subscribe(x => {
            this.betsAndOutcomesForEvents = x;
          });
      } else {
        this.cache.getBetsAndOutcomesForBetTypeGroupForRegion(
          this.selectedBetTypeGroup,
          this.eventsGroupVM.sportId,
          this.eventsGroupVM.regionId,
          this.eventsGroupVM.events,
          this.selectedBetTypeGroupingTemplateItems).subscribe(x => {
            this.betsAndOutcomesForEvents = x;
          });
      }
    } else {
      this.cache.getBetsAndOutcomesForBetTypeGroupForSport(
        this.selectedBetTypeGroup,
        this.eventsGroupVM.sportId,
        this.eventsGroupVM.events,
        this.selectedBetTypeGroupingTemplateItems).subscribe(x => {
          this.betsAndOutcomesForEvents = x;
        });
    }
  }

  // showDetail(event: EventVM) {
  //   this.eventsService.expandEvent(event);
  // }

  // toggleEventOutcome(event: EventVM, bet: IBet, outcome: IBetOutcome, betTypeOutcomeName: string, betTypeName: string) {
  //   if (!((event.isPlayable && bet.isPlayable && outcome.isPlayable) || outcome.isSelected)) {
  //     return;
  //   }
  //   this.ticketService.toggleEventOutcome(event, bet, outcome, betTypeOutcomeName, betTypeName);
  // }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

}
